import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
	mode: 'history',
	routes: [
		{
			path: '*',
			component: resolve => {
				require.ensure(['@/components/NoPage.vue'], () => {
					resolve(require('@/components/NoPage.vue'))
				})
			}
		},
		{
			path: '/pwdtoken/:token',
			redirect: to => {
				return {name: 'entry-password', params: {token: to.params.token}}
			}
		},
		{
			path: '/',
			name: 'app',
			component: resolve => {
				require.ensure(['@/App.vue'], () => {
					resolve(require('@/App.vue'))
				})
			},

			children: [
				// 入口
				{path: 'entry', redirect: {name: 'entry-login'}},
				{
					path: 'entry',
					name: 'entry',
					component: resolve => {
						require.ensure(['@/components/Entry.vue'], () => {
							resolve(require('@/components/Entry.vue'))
						})
					},

					children: [
						// 登录
						{
							path: 'login/:lang?',
							name: 'entry-login',
							component: resolve => {
								require.ensure(['@/components/entry/Login.vue'], () => {
									resolve(require('@/components/entry/Login.vue'))
								})
							}
						}, // entry-login end

						// 注册
						{
							path: 'register/:lang?',
							name: 'entry-register',
							component: resolve => {
								require.ensure(['@/components/entry/Register.vue'], () => {
									resolve(require('@/components/entry/Register.vue'))
								})
							}
						}, // entry-register end

						// 找回密码
						{
							path: 'password',
							name: 'entry-password',
							component: resolve => {
								require.ensure(['@/components/entry/Password.vue'], () => {
									resolve(require('@/components/entry/Password.vue'))
								})
							}
						} // entry-register end
					]
				}, // entry end

				// 广告主
				{ path: 'cp', redirect: { name: 'cp-campaign', params: {app: 'all'} } },
				{
					path: 'cp',
					name: 'cp',
					component: resolve => {
						require.ensure(['@/components/CP.vue'], () => {
							resolve(require('@/components/CP.vue'))
						})
					},

					children: [
						// 广告管理
						{
							path: 'campaign/:app',
							name: 'cp-campaign',
							component: resolve => {
								require.ensure(['@/components/cp/Campaign.vue'], () => {
									resolve(require('@/components/cp/Campaign.vue'))
								})
							}
						},

						// 编辑广告
						{
							path: 'campaignedit/:id',
							name: 'cp-campaignEdit',
							component: resolve => {
								require.ensure(['@/components/cp/CampaignEdit.vue'], () => {
									resolve(require('@/components/cp/CampaignEdit.vue'))
								})
							}
						},

						// 创意管理
						{
							path: 'ads/:campid',
							name: 'cp-ads',
							component: resolve => {
								require.ensure(['@/components/cp/AdsList.vue'], () => {
									resolve(require('@/components/cp/AdsList.vue'))
								})
							}
						},

						// 编辑创意
						{
							path: 'adsedit/campid/:campid/id/:id',
							name: 'cp-adsEdit',
							component: resolve => {
								require.ensure(['@/components/cp/AdsEdit.vue'], () => {
									resolve(require('@/components/cp/AdsEdit.vue'))
								})
							}
						},

						// 财务报表
						{
							path: 'finance',
							name: 'cp-finance',
							component: resolve => {
								require.ensure(['@/components/cp/Finance.vue'], () => {
									resolve(require('@/components/cp/Finance.vue'))
								})
							}
						},

						// 账号管理
						{
							path: 'account',
							name: 'cp-account',
							component: resolve => {
								require.ensure(['@/components/common/Account.vue'], () => {
									resolve(require('@/components/common/Account.vue'))
								})
							}
						},

						// 密码管理
						{
							path: 'password',
							name: 'cp-password',
							component: resolve => {
								require.ensure(['@/components/common/Password.vue'], () => {
									resolve(require('@/components/common/Password.vue'))
								})
							}
						}
					]
				}, // cp end

				{path: 'pub', redirect: {name: 'pub-publish'}},
				// 流量主
				{
					path: 'pub',
					name: 'pub',
					component: resolve => {
						require.ensure(['@/components/Pub.vue'], () => {
							resolve(require('@/components/Pub.vue'))
						})
					},

					children: [
						// 流量管理
						{
							path: 'publish',
							name: 'pub-publish',
							component: resolve => {
								require.ensure(['@/components/pub/Publish.vue'], () => {
									resolve(require('@/components/pub/Publish.vue'))
								})
							}
						},

						// 账号管理
						{
							path: 'account',
							name: 'pub-account',
							component: resolve => {
								require.ensure(['@/components/common/Account.vue'], () => {
									resolve(require('@/components/common/Account.vue'))
								})
							}
						},

						// 密码管理
						{
							path: 'password',
							name: 'pub-password',
							component: resolve => {
								require.ensure(['@/components/common/Password.vue'], () => {
									resolve(require('@/components/common/Password.vue'))
								})
							}
						}
					]
				} // admin end
			]
		}
	]
})



// WEBPACK FOOTER //
// ./src/router/index.js